<script>
export default {}
</script>

<template>
<main id="main" class="site-main hfeed">

				<div data-elementor-type="wp-page" data-elementor-id="405" class="elementor elementor-405">
									<section
                      class="has_eae_slider elementor-section elementor-top-section elementor-element elementor-element-2561f11 elementor-section-height-min-height elementor-section-full_width elementor-section-items-top elementor-reverse-mobile elementor-section-height-default"
                      data-id="2561f11" data-element_type="section"
                      data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
						<div class="elementor-container elementor-column-gap-default">
					<div
              class="has_eae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d594912"
              data-id="d594912" data-element_type="column"
              data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-4f13e01 elementor-widget elementor-widget-heading"
                     data-id="4f13e01" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
          <h2 class="elementor-heading-title elementor-size-default" style="font-size: 30px; line-height: 1.7;">
            قم ببيع سيارتك بسرعة و طريقة خالية من المتاعب بأفضل الأسعار بالأردن!
          </h2>
        </div>
				</div>
				<section
            class="has_eae_slider elementor-section elementor-inner-section elementor-element elementor-element-6934e1e elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="6934e1e" data-element_type="section">
						<div class="elementor-container elementor-column-gap-default">
					<div
              class="has_eae_slider elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-73e5b6a"
              data-id="73e5b6a" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-97735b1 elementor-widget elementor-widget-counter"
                     data-id="97735b1" data-element_type="widget" data-widget_type="counter.default">
				<div class="elementor-widget-container">
          <div class="elementor-counter">
			<div class="elementor-counter-number-wrapper">
				<span class="elementor-counter-number-prefix"></span>
				<span class="elementor-counter-number" data-duration="1000" data-to-value="100" data-from-value="0"
              data-delimiter=",">100</span>
				<span class="elementor-counter-number-suffix">%</span>
			</div>
							<div class="elementor-counter-title">ديجيتال</div>
					</div>
				</div>
				</div>
					</div>
		</div>
				<div
            class="has_eae_slider elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-ca08a65"
            data-id="ca08a65" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-ae180de elementor-widget elementor-widget-counter"
                     data-id="ae180de" data-element_type="widget" data-widget_type="counter.default">
				<div class="elementor-widget-container">
					<div class="elementor-counter">
			<div class="elementor-counter-number-wrapper">
				<span class="elementor-counter-number-prefix"></span>
				<span class="elementor-counter-number">24</span>
				<span class="elementor-counter-number-suffix">ساعة</span>
			</div>
							<div class="elementor-counter-title">المزاودة باي وقت</div>
					</div>
				</div>
				</div>
					</div>
		</div>
				<div
            class="has_eae_slider elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-a619598"
            data-id="a619598" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-d30ff7b elementor-widget elementor-widget-counter"
                     data-id="d30ff7b" data-element_type="widget" data-widget_type="counter.default">
				<div class="elementor-widget-container">
					<div class="elementor-counter">
			<div class="elementor-counter-number-wrapper">
				<span class="elementor-counter-number-prefix"></span>
				<span class="elementor-counter-number" data-duration="100" data-to-value="1" data-from-value="0"
              data-delimiter=",">1</span>
				<span class="elementor-counter-number-suffix"></span>
			</div>
							<div class="elementor-counter-title">مركز إتصال</div>
					</div>
				</div>
				</div>
					</div>
		</div>
							</div>
		</section>
				<div class="elementor-element elementor-element-08b8aef elementor-widget elementor-widget-image"
             data-id="08b8aef" data-element_type="widget" data-widget_type="image.default">
				<div class="elementor-widget-container d-flex justify-content-center">
															<img decoding="async" width="696" height="483"
                                   src="../../../assets/jomazad/images/2022/10/e-class2021_930x620.png"
                                   class="attachment-large size-large lazyautosizes lazyloaded" alt=""
                                   data-src="@/assets/jomazad/images/2022/10/e-class2021_930x620.png"
                                   data-srcset="@/assets/jomazad/images/2022/10/e-class2021_930x620.png 696w, @/assets/jomazad/images/2022/10/e-class2021_930x620-300x208.png 300w, @/assets/jomazad/images/2022/10/e-class2021_930x620-600x416.png 600w"
                                   data-sizes="auto" sizes="696px"
                                   srcset="@/assets/jomazad/images/2022/10/e-class2021_930x620.png 696w, @/assets/jomazad/images/2022/10/e-class2021_930x620-300x208.png 300w, @/assets/jomazad/images/2022/10/e-class2021_930x620-600x416.png 600w"><noscript><img
            decoding="async" width="696" height="483"
            src="@/assets/jomazad/images/2022/10/e-class2021_930x620.png"
            class="attachment-large size-large" alt=""
            srcset="@/assets/jomazad/images/2022/10/e-class2021_930x620.png 696w, @/assets/jomazad/images/2022/10/e-class2021_930x620-300x208.png 300w, @/assets/jomazad/images/2022/10/e-class2021_930x620-600x416.png 600w"
            sizes="(max-width: 696px) 100vw, 696px" data-eio="l"/></noscript>															</div>
				</div>
					</div>
		</div>
							</div>
		</section>
				<section
            class="has_eae_slider elementor-section elementor-top-section elementor-element elementor-element-2eebc93 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="2eebc93" data-element_type="section"
            data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
						<div class="elementor-container elementor-column-gap-default">
					<div
              class="has_eae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-5728965"
              data-id="5728965" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-cee7456 elementor-widget elementor-widget-text-editor"
                     data-id="cee7456" data-element_type="widget" data-widget_type="text-editor.default">
				<div class="elementor-widget-container">
							<p>
                جو مزاد هو أول مزاد إلكتروني للسيارات عبر الإنترنت في الأردن. تهدف إلى تعزيز مفهوم شراء / بيع السيارات في الأردن باستخدام أفضل أنظمة المزادات عبر الإنترنت ، وجذب أكبر عدد ممكن من المشترين ، وبالتالي ، توفير حل متطور للبائعين لتجربة بيع موقوتة ، و تحكم بالأسعار ، وخالِِ من متاعب مشترين السيارات.
كان بيع السيارة عملية طويلة ومحفوفة بالمخاطر. لم يكن المستهلكون متأكدين من القيم الحقيقية لسيارتهم ، وكانوا بحاجة إلى ترتيب الكثير من المواعيد مع ضياع الوقت أو ربما انتهى بهم الأمر إلى السرقة.</p>						</div>
				</div>
				<div
            class="elementor-element elementor-element-2aa5eae elementor-align-left elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
            data-id="2aa5eae" data-element_type="widget" data-widget_type="icon-list.default">
				<div class="elementor-widget-container">
			<ul
          class="elementor-icon-list-items">
							<li class="elementor-icon-list-item">
											<span class="elementor-icon-list-icon">
							<i aria-hidden="true" class="fas fa-dot-circle"></i>						</span>
										<span class="elementor-icon-list-text">تقييم مجاني للسيارة</span>
									</li>
								<li class="elementor-icon-list-item">
											<span class="elementor-icon-list-icon">
							<i aria-hidden="true" class="fas fa-dot-circle"></i>						</span>
										<span class="elementor-icon-list-text">عملية سريعة وموقوتة ومراقبة للأسعار.</span>
									</li>
								<li class="elementor-icon-list-item">
											<span class="elementor-icon-list-icon">
							<i aria-hidden="true" class="fas fa-dot-circle"></i>						</span>
										<span class="elementor-icon-list-text">بيع خالي من المتاعب.</span>
									</li>
								<li class="elementor-icon-list-item">
											<span class="elementor-icon-list-icon">
							<i aria-hidden="true" class="fas fa-dot-circle"></i>						</span>
										<span class="elementor-icon-list-text">موقع الكتروني آمن</span>
									</li>
								<li class="elementor-icon-list-item">
											<span class="elementor-icon-list-icon">
							<i aria-hidden="true" class="fas fa-dot-circle"></i>						</span>
										<span class="elementor-icon-list-text">حافظ على خصوصيتك</span>
									</li>
								<li class="elementor-icon-list-item">
											<span class="elementor-icon-list-icon">
							<i aria-hidden="true" class="fas fa-dot-circle"></i>						</span>
										<span class="elementor-icon-list-text">تعيين سعر الاحتياطي</span>
									</li>
								<li class="elementor-icon-list-item">
											<span class="elementor-icon-list-icon">
							<i aria-hidden="true" class="fas fa-dot-circle"></i>						</span>
										<span class="elementor-icon-list-text">لا تضيع الوقت في إدارة الإعلانات والمكالمات المزعجة</span>
									</li>
						</ul>
				</div>
				</div>
				<div class="elementor-element elementor-element-f6b24cd elementor-widget elementor-widget-text-editor"
             data-id="f6b24cd" data-element_type="widget" data-widget_type="text-editor.default">
				</div>
				<section
            class="has_eae_slider elementor-section elementor-inner-section elementor-element elementor-element-e4a1762 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="e4a1762" data-element_type="section">
						<div class="elementor-container elementor-column-gap-default">
					<div
              class="has_eae_slider elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-c1e45d5"
              data-id="c1e45d5" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-6cd2240 elementor-view-framed elementor-shape-circle elementor-mobile-position-top elementor-vertical-align-top elementor-widget elementor-widget-icon-box"
                    data-id="6cd2240" data-element_type="widget" data-widget_type="icon-box.default">
				<div class="elementor-widget-container">
			<div
          class="elementor-icon-box-wrapper">
						<div class="elementor-icon-box-icon">
				<span class="elementor-icon elementor-animation-">
				<i aria-hidden="true" class="fas fa-user-plus"></i>				</span>
			</div>
						<div class="elementor-icon-box-content">
				<h3 class="elementor-icon-box-title">
					<span>
						سجل سيارتك					</span>
				</h3>
							</div>
		</div>
				</div>
				</div>
					</div>
		</div>
				<div
            class="has_eae_slider elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-14c8ef5"
            data-id="14c8ef5" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-a5b1361 elementor-view-framed elementor-shape-circle elementor-mobile-position-top elementor-vertical-align-top elementor-widget elementor-widget-icon-box"
                    data-id="a5b1361" data-element_type="widget" data-widget_type="icon-box.default">
				<div class="elementor-widget-container">
					<div class="elementor-icon-box-wrapper">
						<div class="elementor-icon-box-icon">
				<span class="elementor-icon elementor-animation-">
				<i aria-hidden="true" class="fas fa-car-side"></i>				</span>
			</div>
						<div class="elementor-icon-box-content">
				<h3 class="elementor-icon-box-title">
					<span>
						إحضار السيارة</span>
				</h3>
							</div>
		</div>
				</div>
				</div>
					</div>
		</div>
				<div
            class="has_eae_slider elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-cf7167f"
            data-id="cf7167f" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-579a224 elementor-view-framed elementor-shape-circle elementor-mobile-position-top elementor-vertical-align-top elementor-widget elementor-widget-icon-box"
                    data-id="579a224" data-element_type="widget" data-widget_type="icon-box.default">
				<div class="elementor-widget-container">
					<div class="elementor-icon-box-wrapper">
						<div class="elementor-icon-box-icon">
				<span class="elementor-icon elementor-animation-">
				<i aria-hidden="true" class="fas fa-gavel"></i>				</span>
			</div>
						<div class="elementor-icon-box-content">
				<h3 class="elementor-icon-box-title">
					<span>
						تباع في المزاد					</span>
				</h3>
							</div>
		</div>
				</div>
				</div>
					</div>
		</div>
				<div
            class="has_eae_slider elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-432f6a8"
            data-id="432f6a8" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-d1fc057 elementor-view-framed elementor-shape-circle elementor-mobile-position-top elementor-vertical-align-top elementor-widget elementor-widget-icon-box"
                    data-id="d1fc057" data-element_type="widget" data-widget_type="icon-box.default">
				<div class="elementor-widget-container">
					<div class="elementor-icon-box-wrapper">
						<div class="elementor-icon-box-icon">
				<span class="elementor-icon elementor-animation-">
				<i aria-hidden="true" class="fas fa-running"></i>				</span>
			</div>
						<div class="elementor-icon-box-content">
				<h3 class="elementor-icon-box-title">
					<span>
						إستلم ثمن السيارة					</span>
				</h3>
							</div>
		</div>
				</div>
				</div>
					</div>
		</div>
							</div>
		</section>
				<section
            class="has_eae_slider elementor-section elementor-inner-section elementor-element elementor-element-8996c62 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="8996c62" data-element_type="section">
						<div class="elementor-container elementor-column-gap-default">
					<div
              class="has_eae_slider elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-elt add ement-588fb23"
              data-id="588fb23" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-980cc09 elementor-widget elementor-widget-heading"
                     data-id="980cc09" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<span class="elementor-heading-title elementor-size-default">
        كما تقدم جو مزاد خدمات ما بعد البيع من تحضير المستندات المطلوبة و خدمات المساعدة في نقل الملكية بدائرة الترخيص.
      </span>		</div>
				</div>
					</div>
		</div>
				<div
            class="has_eae_slider elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-00d7bb7"
            data-id="00d7bb7" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-877e190 elementor-align-center elementor-mobile-align-center elementor-widget elementor-widget-button"
                    data-id="877e190" data-element_type="widget" data-widget_type="button.default">
				<div class="elementor-widget-container">
					<div class="elementor-button-wrapper">
			<router-link :to="{name: 'contact'}" class="btn btn-success rounded-0" role="button" target="_blank">
						<span class="elementor-button-content-wrapper">
						<span class="elementor-button-text">إتصل بنا</span>
		</span>
					</router-link>
		</div>
				</div>
				</div>
					</div>
		</div>
							</div>
		</section>
					</div>
		</div>
							</div>
		</section>
				<section
            class="has_eae_slider elementor-section elementor-top-section elementor-element elementor-element-997b779 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="997b779" data-element_type="section">
						<div class="elementor-container elementor-column-gap-default">
					<div
              class="has_eae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c514171"
              data-id="c514171" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-5ccce80 elementor-widget elementor-widget-heading"
                     data-id="5ccce80" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h2 class="elementor-heading-title elementor-size-default">خدماتنا</h2>		</div>
				</div>
				<section
            class="has_eae_slider elementor-section elementor-inner-section elementor-element elementor-element-9a20a60 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="9a20a60" data-element_type="section">
						<div class="elementor-container elementor-column-gap-default">
					<div
              class="has_eae_slider elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-79f61f7"
              data-id="79f61f7" data-element_type="column"
              data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-2d45cf9 elementor-position-top elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                    data-id="2d45cf9" data-element_type="widget" data-widget_type="image-box.default">
				<div class="elementor-widget-container">
          <div class="elementor-image-box-wrapper"><figure class="elementor-image-box-img"><img decoding="async"
                                                                                                width="62"
                                                                                                height="62"
                                                                                                src="@/assets/jomazad/images/2022/10/mobile-evaluation.svg"
                                                                                                class="elementor-animation-grow attachment-full size-full ls-is-cached lazyloaded"
                                                                                                alt=""
                                                                                                data-src="@/assets/jomazad/images/2022/10/mobile-evaluation.svg"><noscript><img
              decoding="async" width="62" height="62"
              src="@/assets/jomazad/images/2022/10/mobile-evaluation.svg"
              class="elementor-animation-grow attachment-full size-full" alt="" data-eio="l"/></noscript></figure><div
              class="elementor-image-box-content"><h3 class="elementor-image-box-title">تقييم سريع</h3><p
              class="elementor-image-box-description">استفد من تقييمنا المجاني!</p></div></div>		</div>
				</div>
					</div>
		</div>
				<div
            class="has_eae_slider elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-5e859a1"
            data-id="5e859a1" data-element_type="column"
            data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-ec4e273 elementor-position-top elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                    data-id="ec4e273" data-element_type="widget" data-widget_type="image-box.default">
				<div class="elementor-widget-container">
			<div class="elementor-image-box-wrapper"><figure class="elementor-image-box-img"><img decoding="async" width="62"
                                                                                            height="62"
                                                                                            src="@/assets/jomazad/images/2022/10/Self-Evaluation-App.svg"
                                                                                            class="elementor-animation-grow attachment-full size-full ls-is-cached lazyloaded"
                                                                                            alt=""
                                                                                            data-src="@/assets/jomazad/images/2022/10/Self-Evaluation-App.svg"><noscript><img
          decoding="async" width="62" height="62"
          src="@/assets/jomazad/images/2022/10/Self-Evaluation-App.svg"
          class="elementor-animation-grow attachment-full size-full" alt="" data-eio="l"/></noscript></figure><div
          class="elementor-image-box-content"><h3 class="elementor-image-box-title">
        عملية سريعة وموقوتة ومراقبة للأسعار
      </h3><p
          class="elementor-image-box-description">بيع سيارتك في خط زمني من اختيارك
</p></div></div>		</div>
				</div>
					</div>
		</div>
				<div
            class="has_eae_slider elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-bbc7961"
            data-id="bbc7961" data-element_type="column"
            data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-210ee0e elementor-position-top elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                    data-id="210ee0e" data-element_type="widget" data-widget_type="image-box.default">
				<div class="elementor-widget-container">
			<div class="elementor-image-box-wrapper"><figure class="elementor-image-box-img"><img decoding="async" width="62"
                                                                                            height="62"
                                                                                            src="@/assets/jomazad/images/2022/10/24-7-access-to-our-platform.svg"
                                                                                            class="elementor-animation-grow attachment-full size-full ls-is-cached lazyloaded"
                                                                                            alt=""
                                                                                            data-src="@/assets/jomazad/images/2022/10/24-7-access-to-our-platform.svg"><noscript><img
          decoding="async" width="62" height="62"
          src="@/assets/jomazad/images/2022/10/24-7-access-to-our-platform.svg"
          class="elementor-animation-grow attachment-full size-full" alt="" data-eio="l"/></noscript></figure><div
          class="elementor-image-box-content"><h3 class="elementor-image-box-title">
        موقع الكتروني آمن
      </h3><p
          class="elementor-image-box-description">حافظ على خصوصيتك.</p></div></div>		</div>
				</div>
					</div>
		</div>
							</div>
		</section>
				<section
            class="has_eae_slider elementor-section elementor-inner-section elementor-element elementor-element-022e4b3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="022e4b3" data-element_type="section">
						<div class="elementor-container elementor-column-gap-default">
					<div
              class="has_eae_slider elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-70fb6aa"
              data-id="70fb6aa" data-element_type="column"
              data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-3a79e45 elementor-position-top elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                    data-id="3a79e45" data-element_type="widget" data-widget_type="image-box.default">
				<div class="elementor-widget-container">
			<div class="elementor-image-box-wrapper"><figure class="elementor-image-box-img"><img decoding="async" width="62"
                                                                                            height="62"
                                                                                            src="@/assets/jomazad/images/2022/10/Cutting-edge-digital-tools.svg"
                                                                                            class="elementor-animation-grow attachment-full size-full lazyloaded"
                                                                                            alt=""
                                                                                            data-src="@/assets/jomazad/images/2022/10/Cutting-edge-digital-tools.svg"><noscript><img
          decoding="async" width="62" height="62"
          src="@/assets/jomazad/images/2022/10/Cutting-edge-digital-tools.svg"
          class="elementor-animation-grow attachment-full size-full" alt="" data-eio="l"/></noscript></figure><div
          class="elementor-image-box-content"><h3 class="elementor-image-box-title">أدوات رقمية متطورة</h3><p
          class="elementor-image-box-description">مراقبة مزاد سيارتك عالموقع الإلكتروني في كل وقت</p></div></div>		</div>
				</div>
					</div>
		</div>
				<div
            class="has_eae_slider elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-0534254"
            data-id="0534254" data-element_type="column"
            data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-fee1e18 elementor-position-top elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                    data-id="fee1e18" data-element_type="widget" data-widget_type="image-box.default">
				<div class="elementor-widget-container">
			<div class="elementor-image-box-wrapper"><figure class="elementor-image-box-img"><img decoding="async" width="62"
                                                                                            height="62"
                                                                                            src="@/assets/jomazad/images/2022/10/services-buy-1.svg"
                                                                                            class="elementor-animation-grow attachment-full size-full lazyloaded"
                                                                                            alt=""
                                                                                            data-src="@/assets/jomazad/images/2022/10/services-buy-1.svg"><noscript><img
          decoding="async" width="62" height="62"
          src="@/assets/jomazad/images/2022/10/services-buy-1.svg"
          class="elementor-animation-grow attachment-full size-full" alt="" data-eio="l"/></noscript></figure><div
          class="elementor-image-box-content"><h3 class="elementor-image-box-title">حدد السعر الاحتياطي</h3><p
          class="elementor-image-box-description">تأكد من البيع بالسعر الذي تختاره</p></div></div>		</div>
				</div>
					</div>
		</div>
				<div
            class="has_eae_slider elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-d65dde5"
            data-id="d65dde5" data-element_type="column"
            data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-516f64f elementor-position-top elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                    data-id="516f64f" data-element_type="widget" data-widget_type="image-box.default">
				<div class="elementor-widget-container">
			<div class="elementor-image-box-wrapper"><figure class="elementor-image-box-img"><img decoding="async" width="62"
                                                                                            height="62"
                                                                                            src="@/assets/jomazad/images/2022/10/Dedicated-account-management-team.svg"
                                                                                            class="elementor-animation-grow attachment-full size-full lazyloaded"
                                                                                            alt=""
                                                                                            data-src="@/assets/jomazad/images/2022/10/Dedicated-account-management-team.svg"><noscript><img
          decoding="async" width="62" height="62"
          src="@/assets/jomazad/images/2022/10/Dedicated-account-management-team.svg"
          class="elementor-animation-grow attachment-full size-full" alt="" data-eio="l"/></noscript></figure><div
          class="elementor-image-box-content"><h3 class="elementor-image-box-title">فريق متخصص</h3><p
          class="elementor-image-box-description">فريقنا موجود لدعم احتياجات البيع الخاصة بك
</p></div></div>		</div>
				</div>
					</div>
		</div>
							</div>
		</section>
					</div>
		</div>
							</div>
		</section>
				<section
            class="has_eae_slider elementor-section elementor-top-section elementor-element elementor-element-1abf7cd elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="1abf7cd" data-element_type="section">
						<div class="elementor-container elementor-column-gap-default">
					<div
              class="has_eae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-8892870"
              data-id="8892870" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-bc466d3 elementor-align-center elementor-mobile-align-center elementor-widget elementor-widget-button"
                    data-id="bc466d3" data-element_type="widget" data-widget_type="button.default">
				<div class="elementor-widget-container">
					<div class="elementor-button-wrapper">
			<router-link :to="{name: 'add.car'}" class="btn btn-success rounded-0" role="button">
						<span class="elementor-button-content-wrapper">
						<span class="elementor-button-text">بيع سيارتك</span>
		</span>
					</router-link>
		</div>
				</div>
				</div>
					</div>
		</div>
							</div>
		</section>
				<section
            class="has_eae_slider elementor-section elementor-top-section elementor-element elementor-element-b0c20ec elementor-hidden-desktop elementor-hidden-tablet elementor-hidden-mobile elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="b0c20ec" data-element_type="section"
            data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;shape_divider_top&quot;:&quot;zigzag&quot;}">
					<div class="elementor-shape elementor-shape-top" data-negative="false">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1800 5.8" preserveAspectRatio="none">
  <path class="elementor-shape-fill"
        d="M5.4.4l5.4 5.3L16.5.4l5.4 5.3L27.5.4 33 5.7 38.6.4l5.5 5.4h.1L49.9.4l5.4 5.3L60.9.4l5.5 5.3L72 .4l5.5 5.3L83.1.4l5.4 5.3L94.1.4l5.5 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.4 5.3L161 .4l5.4 5.3L172 .4l5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.5 5.3L261 .4l5.4 5.3L272 .4l5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.7-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.4h.2l5.6-5.4 5.5 5.3L361 .4l5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.7-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.6-5.4 5.5 5.3L461 .4l5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1L550 .4l5.4 5.3L561 .4l5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2L650 .4l5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2L750 .4l5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.7-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.4h.2L850 .4l5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.4 5.3 5.7-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.7-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.4 5.3 5.7-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.7-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.7-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.4h.2l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.7-5.4 5.4 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.5 5.4h.1l5.6-5.4 5.5 5.3 5.6-5.3 5.5 5.3 5.6-5.3 5.4 5.3 5.7-5.3 5.4 5.3 5.6-5.3 5.5 5.4V0H-.2v5.8z"></path>
</svg>
		</div>
					<div class="elementor-container elementor-column-gap-default">
					<div
              class="has_eae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-9814db9"
              data-id="9814db9" data-element_type="column">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-6fde0c8 elementor-widget elementor-widget-heading"
                     data-id="6fde0c8" data-element_type="widget" data-widget_type="heading.default">
				<div class="elementor-widget-container">
			<h2 class="elementor-heading-title elementor-size-default">Your advantages with Jo Mazad
</h2>		</div>
				</div>
				<section
            class="has_eae_slider elementor-section elementor-inner-section elementor-element elementor-element-b2cbd68 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="b2cbd68" data-element_type="section">
						<div class="elementor-container elementor-column-gap-default">
					<div
              class="has_eae_slider elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-531c911"
              data-id="531c911" data-element_type="column"
              data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-875ba0c elementor-align-left elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                    data-id="875ba0c" data-element_type="widget" data-widget_type="icon-list.default">
				<div class="elementor-widget-container">
					<ul class="elementor-icon-list-items">
							<li class="elementor-icon-list-item">
											<span class="elementor-icon-list-icon">
							<i aria-hidden="true" class="fas fa-check"></i>						</span>
										<span class="elementor-icon-list-text">Best prices in Europe</span>
									</li>
						</ul>
				</div>
				</div>
				<div class="elementor-element elementor-element-523c290 elementor-widget elementor-widget-text-editor"
             data-id="523c290" data-element_type="widget" data-widget_type="text-editor.default">
				<div class="elementor-widget-container">
							<p>We have a network of over 60,000 active buyers from 30 markets that will drive up the price of your car at auction. Benefit from local price differences and active selling of Jo Mazad in the respective national language.</p>						</div>
				</div>
					</div>
		</div>
				<div
            class="has_eae_slider elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-99279a9"
            data-id="99279a9" data-element_type="column"
            data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-172fe1b elementor-align-left elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                    data-id="172fe1b" data-element_type="widget" data-widget_type="icon-list.default">
				<div class="elementor-widget-container">
					<ul class="elementor-icon-list-items">
							<li class="elementor-icon-list-item">
											<span class="elementor-icon-list-icon">
							<i aria-hidden="true" class="fas fa-check"></i>						</span>
										<span class="elementor-icon-list-text">Sell your car faster</span>
									</li>
						</ul>
				</div>
				</div>
				<div class="elementor-element elementor-element-9e68062 elementor-widget elementor-widget-text-editor"
             data-id="9e68062" data-element_type="widget" data-widget_type="text-editor.default">
				<div class="elementor-widget-container">
							<p>No need to wait for time-consuming theme auctions! The auction of your car starts directly and will finish within 24 hours. Every car is sold individually – there are no block auctions.</p>						</div>
				</div>
					</div>
		</div>
							</div>
		</section>
				<section
            class="has_eae_slider elementor-section elementor-inner-section elementor-element elementor-element-3a68296 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="3a68296" data-element_type="section">
						<div class="elementor-container elementor-column-gap-default">
					<div
              class="has_eae_slider elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-aca15a1"
              data-id="aca15a1" data-element_type="column"
              data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-af49307 elementor-align-left elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                    data-id="af49307" data-element_type="widget" data-widget_type="icon-list.default">
				<div class="elementor-widget-container">
					<ul class="elementor-icon-list-items">
							<li class="elementor-icon-list-item">
											<span class="elementor-icon-list-icon">
							<i aria-hidden="true" class="fas fa-check"></i>						</span>
										<span class="elementor-icon-list-text">No risk and zero hassle</span>
									</li>
						</ul>
				</div>
				</div>
				<div class="elementor-element elementor-element-e7db4dc elementor-widget elementor-widget-text-editor"
             data-id="e7db4dc" data-element_type="widget" data-widget_type="text-editor.default">
				<div class="elementor-widget-container">
							<p>AUTO1.com remains your sole contractual partner throughout the whole process. After the auction, we buy the car and sell it to the buyer. We also handle the export and have an audit-proof Remarketing process.</p>						</div>
				</div>
					</div>
		</div>
				<div
            class="has_eae_slider elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-19722ca"
            data-id="19722ca" data-element_type="column"
            data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-885606e elementor-align-left elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                    data-id="885606e" data-element_type="widget" data-widget_type="icon-list.default">
				<div class="elementor-widget-container">
					<ul class="elementor-icon-list-items">
							<li class="elementor-icon-list-item">
											<span class="elementor-icon-list-icon">
							<i aria-hidden="true" class="fas fa-check"></i>						</span>
										<span class="elementor-icon-list-text">Active selling of your car</span>
									</li>
						</ul>
				</div>
				</div>
				<div class="elementor-element elementor-element-9dc9f01 elementor-widget elementor-widget-text-editor"
             data-id="9dc9f01" data-element_type="widget" data-widget_type="text-editor.default">
				<div class="elementor-widget-container">
							<p>Local sales representatives and holistic marketing activities push the sale of your cars in the languages of the potential buyers.</p>						</div>
				</div>
					</div>
		</div>
							</div>
		</section>
				<section
            class="has_eae_slider elementor-section elementor-inner-section elementor-element elementor-element-96df0f0 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="96df0f0" data-element_type="section">
						<div class="elementor-container elementor-column-gap-default">
					<div
              class="has_eae_slider elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-6f4916c"
              data-id="6f4916c" data-element_type="column"
              data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-702fdf1 elementor-align-left elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                    data-id="702fdf1" data-element_type="widget" data-widget_type="icon-list.default">
				<div class="elementor-widget-container">
					<ul class="elementor-icon-list-items">
							<li class="elementor-icon-list-item">
											<span class="elementor-icon-list-icon">
							<i aria-hidden="true" class="fas fa-check"></i>						</span>
										<span class="elementor-icon-list-text">Easy and 100% digital</span>
									</li>
						</ul>
				</div>
				</div>
				<div class="elementor-element elementor-element-7acef6c elementor-widget elementor-widget-text-editor"
             data-id="7acef6c" data-element_type="widget" data-widget_type="text-editor.default">
				<div class="elementor-widget-container">
							<p>All transactions are managed end-to-end digitally via the intuitive Jo Mazad Auction platform. You can monitor all actions on the website or the dashboard.</p>						</div>
				</div>
					</div>
		</div>
				<div
            class="has_eae_slider elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-a4a5d55"
            data-id="a4a5d55" data-element_type="column"
            data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
			<div class="elementor-widget-wrap elementor-element-populated">
								<div
                    class="elementor-element elementor-element-0e615da elementor-align-left elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                    data-id="0e615da" data-element_type="widget" data-widget_type="icon-list.default">
				<div class="elementor-widget-container">
					<ul class="elementor-icon-list-items">
							<li class="elementor-icon-list-item">
											<span class="elementor-icon-list-icon">
							<i aria-hidden="true" class="fas fa-check"></i>						</span>
										<span class="elementor-icon-list-text">Personal Contact</span>
									</li>
						</ul>
				</div>
				</div>
				<div class="elementor-element elementor-element-73fff9b elementor-widget elementor-widget-text-editor"
             data-id="73fff9b" data-element_type="widget" data-widget_type="text-editor.default">
				<div class="elementor-widget-container">
							<p>We are digital but you can also contact us directly! Our industry experts can consult you via phone or email and help boost your business.</p>						</div>
				</div>
					</div>
		</div>
							</div>
		</section>
				<div
            class="elementor-element elementor-element-3e60e08 elementor-align-center elementor-mobile-align-center elementor-widget elementor-widget-button"
            data-id="3e60e08" data-element_type="widget" data-widget_type="button.default">
				<div class="elementor-widget-container">
					<div class="elementor-button-wrapper">
			<a href="/sell-form/" class="elementor-button-link elementor-button elementor-size-sm" role="button">
						<span class="elementor-button-content-wrapper">
						<span class="elementor-button-text">JOIN NOW</span>
		</span>
					</a>
		</div>
				</div>
				</div>
					</div>
		</div>
							</div>
		</section>
							</div>
			</main>
</template>

<style scoped>
@import "https://jomazad.com/wp-content/uploads/elementor/css/global.css";
@import "../../../assets/jomazad/css/sell-car.css";
</style>